<template>
  <section class="section__lineup">
    <div class="c__container">
      <div class="c__headblock">
        <h2 class="c__leadcopy navy c__no__anm"> 2025春夏新商品ラインナップ </h2>
      </div>
      <div class="lineup__wrap">
        <div class="lineup__container">
          <div class="table__wrap">
            <div class="table__head">
              <div class="lineup__head"></div>
            </div>
            <div class="lineup__body">
              <p class="column2">価格</p>
              <p class="column1">対象</p>
              <p class="column1">素材</p>
              <p class="column1">サイズ</p>
              <p class="column2">カラー</p>
              <p class="column1">季節</p>
            </div>
          </div>
          <div v-if="products.length === 0" class="lineup__loading">
            <AtomsConsumerLoading />
          </div>
          <div v-show="products.length > 0" ref="carousel" class="swiper lineup-swiper">
            <div class="swiper-wrapper">
              <div v-for="product in products" :key="`lineup-${product.name}`">
                <FeaturesHowtochooseRecoverywearSleepitemPartsRecommendLineupItem :product="product" />
              </div>
            </div>
            <div v-if="canScrollNext" class="swiper-button-next" @click="emblaApi?.scrollNext()">
              <AtomsConsumerImage
                src="/images/site/feature/howtochoose_recoverywear_sleepitem/next-icon.svg"
                alt="次の商品"
                :width="24"
                :height="24"
              />
            </div>
            <div v-if="canScrollPrev" class="swiper-button-prev" @click="emblaApi?.scrollPrev()">
              <AtomsConsumerImage
                src="/images/site/feature/howtochoose_recoverywear_sleepitem/prev-icon.svg"
                alt="前の商品"
                :width="24"
                :height="24"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import emblaCarouselVue from "embla-carousel-vue"
import { RecommendLineupProduct } from "~/utils/functions/howtochoose_recoverywear_sleepitem"

const [carousel, emblaApi] = emblaCarouselVue({ align: "start" })

defineProps<{
  products: RecommendLineupProduct[]
}>()

const canScrollNext = ref(false)
const canScrollPrev = ref(false)
const isFirstView = ref(true)
const sessionKey = "howtochoose_recoverywear_sleepitem_recommendLineup"

watch(
  emblaApi,
  (api) => {
    if (api) {
      api.on("select", (event) => {
        canScrollNext.value = event.canScrollNext() || false
        canScrollPrev.value = event.canScrollPrev() || false

        // 表示している商品をセッションストレージに保存
        sessionStorage.setItem(sessionKey, event.selectedScrollSnap().toString())
      })
      api.on("slidesInView", (event) => {
        if (isFirstView.value) {
          isFirstView.value = false
          canScrollNext.value = event.canScrollNext() || false
          canScrollPrev.value = event.canScrollPrev() || false

          const savedRecommendLineup = sessionStorage.getItem(sessionKey)
          if (savedRecommendLineup) {
            event.scrollTo(parseInt(savedRecommendLineup), true)
          }
        }
      })
    }
  },
  { immediate: true },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
